import { PureComponent } from "react";

class TopicIcon extends PureComponent {
  render() {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 19V3C18 1.89543 17.1046 1 16 1H6C4.89543 1 4 1.89543 4 3V19C4 20.1046 4.89543 21 6 21H16C17.1046 21 18 20.1046 18 19Z"
          fill="#460584"
        />
        <path
          d="M20 21V5C20 3.89543 19.1046 3 18 3H8C6.89543 3 6 3.89543 6 5V21C6 22.1046 6.89543 23 8 23H18C19.1046 23 20 22.1046 20 21Z"
          fill="url(#paint0_linear_3833_25433)"
        />
        <path
          d="M17 5H9C8.44772 5 8 5.44772 8 6V11C8 11.5523 8.44772 12 9 12H17C17.5523 12 18 11.5523 18 11V6C18 5.44772 17.5523 5 17 5Z"
          fill="#E8C1FF"
        />
        <path
          d="M17.5 14H8.5C8.22386 14 8 14.2239 8 14.5C8 14.7761 8.22386 15 8.5 15H17.5C17.7761 15 18 14.7761 18 14.5C18 14.2239 17.7761 14 17.5 14Z"
          fill="#E8C1FF"
        />
        <path
          d="M15.5 16H8.5C8.22386 16 8 16.2239 8 16.5C8 16.7761 8.22386 17 8.5 17H15.5C15.7761 17 16 16.7761 16 16.5C16 16.2239 15.7761 16 15.5 16Z"
          fill="#E8C1FF"
        />
        <path
          d="M16.5 18H8.5C8.22386 18 8 18.2239 8 18.5C8 18.7761 8.22386 19 8.5 19H16.5C16.7761 19 17 18.7761 17 18.5C17 18.2239 16.7761 18 16.5 18Z"
          fill="#E8C1FF"
        />
        <path
          d="M11.5 20H8.5C8.22386 20 8 20.2239 8 20.5C8 20.7761 8.22386 21 8.5 21H11.5C11.7761 21 12 20.7761 12 20.5C12 20.2239 11.7761 20 11.5 20Z"
          fill="#E8C1FF"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3833_25433"
            x1="8.5"
            y1="19.5"
            x2="19.4523"
            y2="7.4097"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#630FB3" />
            <stop offset="1" stopColor="#BD58FB" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}

export default TopicIcon;
